/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Zotero_Reload_LibraryInputs */

const en_zotero_reload_library = /** @type {(inputs: Zotero_Reload_LibraryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reload library`)
};

const es_zotero_reload_library = /** @type {(inputs: Zotero_Reload_LibraryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recargar biblioteca`)
};

/**
* | output |
* | --- |
* | "Reload library" |
*
* @param {Zotero_Reload_LibraryInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const zotero_reload_library = /** @type {((inputs?: Zotero_Reload_LibraryInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Zotero_Reload_LibraryInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_zotero_reload_library(inputs)
	return en_zotero_reload_library(inputs)
});